import React, { useEffect, useMemo, useState } from 'react';
import './TeamBadge.css';
import Tooltip from './Tooltip';

function slugifyTeam(team = '') {
  return team
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
}

function getInitials(team = '') {
  return team
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join('');
}

export default function TeamBadge({ team, size = 46, showTooltip = true }) {
  const [broken, setBroken] = useState(false);
  const [retryUpper, setRetryUpper] = useState(false);

  const slug = useMemo(() => slugifyTeam(team), [team]);
  const baseUrl = process.env.PUBLIC_URL || '';

  useEffect(() => {
    setBroken(false);
    setRetryUpper(false);
  }, [team, slug]);

  const imgSrc = retryUpper
    ? `${baseUrl}/team-logos/${slug}.PNG`
    : `${baseUrl}/team-logos/${slug}.png`;

  return (
    <Tooltip
      as="div"
      className="team-badge"
      style={{ width: size, height: size }}
      content={showTooltip ? (team || 'Squadra') : undefined}
      aria-label={team || 'Squadra'}
    >
      {!broken ? (
        <img
          className="team-badge__img"
          src={imgSrc}
          alt={team || 'Squadra'}
          onError={() => {
            if (!retryUpper) {
              setRetryUpper(true);
            } else {
              setBroken(true);
            }
          }}
          loading="lazy"
          decoding="async"
        />
      ) : (
        <span className="team-badge__fallback">{getInitials(team)}</span>
      )}
    </Tooltip>
  );
}